export default "__VITE_ASSET__90ef950d__"